import React from "react";
import styled from "styled-components";
import {NextSeo} from "next-seo";
import "mapbox-gl/dist/mapbox-gl.css";

import Page from "../../../components/Page";
import NewsItem from "../../../components/NewsItem";
import Pagination from "../../../components/Pagination";
import {news_list} from "../../../api/news";
import withRouter from "next/dist/client/with-router";

const Container = styled.div`
  width: 90%;
  margin: auto;
  max-width: 800px;
  margin-top: 50px;
  padding-bottom: 50px;
`;

class News extends React.Component {
  render() {
    const current_language = this.props.router.locale;

    return (
      <Page>
        <NextSeo title="News" description="News." />

        <Container>
          {this.props.posts.map(post => (
            <NewsItem key={post.id} post={post} />
          ))}
          <Pagination
            changeUrl={"/" + current_language + "/news/page/"}
            page={this.props.page}
            items={10}
            count={this.props.count}
          />
        </Container>
      </Page>
    );
  }
}

export async function getServerSideProps(context) {
  try {
    const language = context.locale || "en";
    const {page} = context.query;
    const page_number = parseInt(page);

    if (isNaN(page_number)) {
      return {
        notFound: true,
      };
    }

    const res = await news_list(page_number, language);
    const posts = res.results || [];

    return {
      props: {
        count: res.count,
        posts,
        page: page_number,
      },
    };
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export default withRouter(News);
